module.exports = __webpack_public_path__ + "img/f737de5.jpg";